import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthWithBoxEmailSent() {
	return <AuthShell variant="with-box"><AuthForm variant="with-box" mode="email-sent" /></AuthShell>;
}

export default AuthWithBoxEmailSent;
